import {load} from '@cashfreepayments/cashfree-js';
export const cashfree = await load({
	mode: process.env.REACT_APP_CASHFREE_ENV //or production
});